import { styled, theme } from '../../lib/stitches'

export const StyledKBD = styled('kbd', {
  boxSizing: 'border-box',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: theme.sizes.ui_20,
  minWidth: theme.sizes.ui_20,
  padding: `0 ${theme.sizes.ui_04}`,
  backgroundColor: theme.colors.ui_neutral02,
  color: theme.colors.ui_neutral04,
  borderRadius: theme.sizes.ui_04,
  border: `1px solid ${theme.colors.ui_neutral03}`,
  fontSize: 11,
  fontWeight: theme.fontWeights.medium,
  fontFamily: theme.fonts.sans
})
